import Button from "./FilterButton";
import Info from "./FilterInfo";

export default { Button, Info };
